import { BeatResolution } from '@arpeggi/shared'
import { Arp2Utils } from '../../client/SongUtils'
import { IDrumSubLoopStore } from '../../stores/song/loop/DrumSubLoopStore'
import { INoteCollectionStore } from '../../stores/song/loop/NoteCollectionStore'
import { DrumGenerator } from '../DrumGenerator'
import { RandIndex, RandProb } from '../RandomUtils'

// The classic Arpeggi Trap sound
export class TrapDrumGenerator implements DrumGenerator {
  generateDrumSubloopForCategory(subLoop: IDrumSubLoopStore, category: string) {
    switch (category) {
      case 'Kick':
        return this.generateKickSubloop(subLoop)
      case 'Snare':
      case 'Clap':
      case 'Snap':
      case 'Rim':
        return this.generateSnareSubloop(subLoop)
      case 'Closed':
        return this.generateClosedHatSubloop(subLoop)
      case 'Perc':
      case 'Open':
      default:
        return this.generatePercSubloop(subLoop)
    }
  }
  generateKickSubloop(subLoop: IDrumSubLoopStore) {
    const resolution = BeatResolution.EIGHTH_NOTE
    const length = Arp2Utils.getLengthOfRes(resolution)
    const half = length / 2

    let kick: boolean[] = Array(length).fill(false)
    kick[0] = true
    kick[16] = true

    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 3)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 6)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 13)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 9)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 10)

    // Can also duplicate the first half. But not as interesting rhythms.
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 3 + half)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 6 + half)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 13 + half)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 9 + half)
    if (RandProb(0.1)) TrapDrumGenerator.invert(kick, 10 + half)

    subLoop.settings.resolution = resolution
    const noteCollection = subLoop.notes as INoteCollectionStore
    noteCollection.populateFromDrumBooleanArray(kick)
  }

  generateSnareSubloop(subLoop: IDrumSubLoopStore) {
    const resolution = BeatResolution.EIGHTH_NOTE
    const length = Arp2Utils.getLengthOfRes(resolution)
    const half = length / 2

    let snare: boolean[] = Array(length).fill(false)
    snare[4] = true
    snare[12] = true
    snare[4 + half] = true
    snare[12 + half] = true

    if (RandProb(0.15)) TrapDrumGenerator.invert(snare, 7)
    if (RandProb(0.1) || (snare[7] === true && RandProb(0.5))) TrapDrumGenerator.invert(snare, 9)
    if (RandProb(0.1)) TrapDrumGenerator.invert(snare, 15)

    if (RandProb(0.15)) TrapDrumGenerator.invert(snare, 7 + half)
    if (RandProb(0.1) || (snare[7 + half] === true && RandProb(0.5)))
      TrapDrumGenerator.invert(snare, 9 + half)
    if (RandProb(0.1)) TrapDrumGenerator.invert(snare, 15 + half)

    subLoop.settings.resolution = resolution
    const noteCollection = subLoop.notes as INoteCollectionStore
    noteCollection.populateFromDrumBooleanArray(snare)
  }

  generateClosedHatSubloop(subLoop: IDrumSubLoopStore) {
    const resolution = BeatResolution.SIXTEENTH_NOTE
    const length = Arp2Utils.getLengthOfRes(resolution)
    console.log('generating closed hat subloop')
    let hatTime = 1
    if (RandProb(0.5)) hatTime = 2

    let hat: boolean[] = Array(length).fill(false)

    for (var i = 0; i < length; i += hatTime) {
      // On an off beat
      if (i % (hatTime * 2) !== 0 && RandProb(0.3 / hatTime)) {
        TrapDrumGenerator.invert(hat, i)
      }

      if (i % (hatTime * 2) === 0) {
        if (!hat[i]) TrapDrumGenerator.invert(hat, i)
      }
    }

    // Now go thru and add some rolls
    for (let i = 0; i < length; i++) {
      // On a super off beat
      if (i % hatTime !== 0) {
        // Only invert if a roll
        if (hat[(i - 1) % length] && hat[(i + 1) % length] && RandProb(0.4)) {
          TrapDrumGenerator.invert(hat, i)
        } else {
          continue
        }
      }
    }

    subLoop.settings.resolution = resolution
    const noteCollection = subLoop.notes as INoteCollectionStore
    noteCollection.populateFromDrumBooleanArray(hat)
  }

  // This one is just random, just for fun
  generatePercSubloop(subLoop: IDrumSubLoopStore) {
    const resolution = BeatResolution.EIGHTH_NOTE
    const length = Arp2Utils.getLengthOfRes(resolution)
    const half = length / 2

    let perc: boolean[] = Array(length).fill(false)

    let randomIndex = RandIndex(perc)
    TrapDrumGenerator.invert(perc, randomIndex)
    TrapDrumGenerator.invert(perc, randomIndex + (1 % length))

    let randomIndex2 = RandIndex(perc)
    TrapDrumGenerator.invert(perc, randomIndex2)
    TrapDrumGenerator.invert(perc, randomIndex2 + (1 % length))

    subLoop.settings.resolution = resolution
    const noteCollection = subLoop.notes as INoteCollectionStore
    noteCollection.populateFromDrumBooleanArray(perc)
  }

  // Flips the index from 0 to 1 or true to false
  static invert(array: Array<Boolean>, index) {
    array[index] = !array[index]
  }
}
